import React, {useState, useEffect} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {db, firestore} from "../firebase";
import {doc, getDoc} from "firebase/firestore";
import {ref, update} from "firebase/database";
import {useAuth} from "../contexts/AuthContext";
import "./PersonalRegistration.css";

export default function SchoolPaymentSuccess() {
  const [loading, setLoading] = useState(true);
  const [orderDetails, setOrderDetails] = useState(null);
  const [licenseDetails, setLicenseDetails] = useState(null);
  const [userDetails] = useState(null);
  const [error, setError] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const {currentUser} = useAuth();

  const params = new URLSearchParams(location.search);
  const orderId = params.get("order_id");

  useEffect(() => {
    const fetchOrderDetails = async () => {
      if (!orderId) {
        setError("1. 주문 ID가 없습니다.");
        setLoading(false);
        return;
      }

      try {
        // 결제 정보 조회 (Firestore)
        const orderDoc = await getDoc(doc(firestore, "payments", orderId));
        if (!orderDoc.exists()) {
          setError("2. 주문 정보를 찾을 수 없습니다.");
          setLoading(false);
          return;
        }
        const orderData = orderDoc.data();
        setOrderDetails(orderData);

        // // 라이선스 정보 조회 (Firestore)
        // const docKey = currentUser.uid + "_" + orderId;
        // const licenseDocRef = doc(firestore, "licenses", docKey);
        // const licenseDoc = await getDoc(licenseDocRef);
        // if (!licenseDoc.exists()) {
        //   setError("3. 라이선스 정보를 찾을 수 없습니다.");
        //   setLoading(false);
        //   return;
        // }
        // const licenseData = licenseDoc.data();
        // setLicenseDetails(licenseData);

        // 결제 완료 후 학습 시작 표시 (Realtime Database)
        // if (currentUser && orderData.status === "completed") {
        //   await activateLearningAccess(currentUser.uid, licenseData.created_at);
        // }
      } catch (error) {
        console.error("데이터 조회 에러:", error);
        setError("4. 주문 정보를 불러오는 중 오류가 발생했습니다.");
      } finally {
        setLoading(false);
      }
    };

    fetchOrderDetails();
  }, [orderId, currentUser]);

  const handleGoToDashboard = () => {
    navigate("/dashboard");
  };
  const handleGoToApp = () => {
    if(orderDetails && orderDetails.item_name && orderDetails.item_name.startsWith("Premium")) {
      window.open("https://app.chocopython.org", "_blank");
    }
    else if(orderDetails && orderDetails.item_name && orderDetails.item_name.startsWith("Lite")) {
      window.open("https://e.chocopython.org", "_blank");
    }
    else if(orderDetails && orderDetails.item_name && orderDetails.item_name.startsWith("Basic")) {
      window.open("https://basic.chocopython.org", "_blank");
    }
    else {
      window.open("https://chocopython.org", "_blank");
    }
  };

  if (loading) {
    return <div className="container mx-auto p-4 text-center">로딩 중...</div>;
  }

  if (error) {
    return (
      <div className="container mx-auto p-4">
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">{error}</div>
        <button
          className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded"
          onClick={handleGoToDashboard}
        >
          대시보드로 이동
        </button>
      </div>
    );
  }

  return (
    <section className="position-relative overflow-hidden pt-5 pt-lg-3">
      <div className="mx-auto p-4">
        <div className="bg-warning bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-6">
          <h1 className="text-2xl font-bold">결제 완료!</h1>
          <p>고객센터 : 학습 서비스 준비 후 안내드리겠습니다.</p>
        </div>

        {orderDetails && (
          <div className="card-body bg-white shadow-md rounded p-6 mb-6">
            <h2 className="text-xl font-bold mb-4">주문 정보</h2>
            <p><strong>상품명:</strong> {orderDetails.item_name}</p>
            <p><strong>수량:</strong> {orderDetails.quantity}</p>
            <p><strong>결제 금액:</strong> {Number(orderDetails.total_amount).toLocaleString()}원</p>
            <p><strong>결제 상태:</strong> {orderDetails.status === "completed" ? "완료" : "처리 중"}</p>
            <p><strong>주문 번호:</strong> {orderId}</p>
          </div>
        )}

        {userDetails && (
          <div className="card bg-white shadow-md rounded p-6 mb-6">
            <h2 className="text-xl font-bold mb-4">사용자 계정</h2>
            <p><strong>이메일:</strong> {userDetails.email}</p>
          </div>
        )}

        <div className="mt-6">
          <button
            className="btn-primary w-auto px-6 py-3"
            onClick={handleGoToApp}
          >
            초코파이썬 학습앱 시작하기
          </button>
        </div>
      </div>
    </section>
  );
}